import {Component, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {TorchQueryFilter} from '../../../../../../../../@backend/modules/@filters/torch-query-filter.model';
import {MatButton} from '@angular/material/button';
import {TorchQueryFiltersService} from '../../../../../../../../@backend/modules/@filters/torch-query-filters.service';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, switchMap} from 'rxjs/operators';
import {ThemePalette} from '@angular/material/core';
import {MatMenuTrigger} from '@angular/material/menu';
import {QUERY_FILTER_ICONS} from './query-filter-icons';

@Component({
  selector: 'app-query-filter-edit',
  templateUrl: './query-filter-edit.component.html',
  styleUrls: ['./query-filter-edit.component.scss']
})
export class QueryFilterEditComponent {

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  @Output()
  queryFilterUpdated = new EventEmitter<TorchQueryFilter>(true);

  filterIcons = QUERY_FILTER_ICONS;


  @Input()
  set type(type: 'EDIT' | 'NEW') {
    if (!!type) {
      this._type = type;
    }
  }

  @Input()
  set queryFilter(queryFilter: TorchQueryFilter) {
    this._queryFilter = queryFilter;
    this.displayName = queryFilter.displayName || '';
    this.icon = (queryFilter.metadata || {icon: null}).icon || 'rule';

    if (this._type === 'EDIT' && this.displayName.length) {
      this.fieldLabel = `Renaming '${this.displayName}'`;
    } else {
      this.fieldLabel = 'New Filter';
    }
  }

  get queryFilter() {
    return this._queryFilter;
  }

  filterName = new Subject<string>();
  filterNameError = new Subject<string>();
  displayName: string;
  icon: string;
  _queryFilter: TorchQueryFilter;
  buttonColor: ThemePalette = null;
  buttonText = 'Done';
  fieldLabel = 'New Filter';

  private _type: 'EDIT' | 'NEW' = 'EDIT';

  constructor(private queryFilterService: TorchQueryFiltersService) {
    this.filterNameError.subscribe(err => {
      this.buttonColor = (!!err ? 'warn' : null);
      this.buttonText = (!!err ? 'Overwrite' : 'Save');
    });

    this.filterName.pipe(
      filter(v => !!v && v.length > 0),
      filter(displayName => displayName !== this.queryFilter.displayName),
      debounceTime(150),
      distinctUntilChanged(),
      switchMap(filterName => this.queryFilterService.checkExists(filterName))
    ).subscribe(exists => {
      if (exists) {
        this.filterNameError.next('A filter with this name already exists. Saving a filter with this name will overwrite it.');
      } else {
        this.filterNameError.next(null);
      }
    });
  }

  toggleIconMenu(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.trigger.toggleMenu();
  }

  done(button: MatButton) {
    button.disabled = true;
    this.queryFilter.displayName = this.displayName.trim();
    this.queryFilter.metadata = {...(this.queryFilter.metadata || {}), icon: this.icon};

    if (this.buttonText === 'Done') {
      this.queryFilterUpdated.next(null);
    } else {
      this.queryFilterUpdated.next(this.queryFilter);
    }
  }

  iconSelected(icon: string) {
    this.buttonText = 'Save';
    this.icon = icon;
  }

  filterNameUpdated(name: string) {
    this.filterName.next(name);
  }

  get doneDisabled() {
    return this.displayName.length === 0;
  }

  setDisplayName(displayName: string) {
    this.displayName = displayName;
    this.filterNameUpdated(displayName);
  }
}
